/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/error';
import '../resources/datatypes';
import './interfaces-common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "RetrieveCatalogObjectRequest": {
                        "fields": {
                          "objectId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "includeRelatedObjects": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeCounts": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "catalogVersion": {
                            "type": "int64",
                            "id": 4,
                            "rule": "optional"
                          },
                          "includeCategoryPathToRoot": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeCategoryEnablementForCombos": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeInventory": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          }
                        }
                      },
                      "RetrieveCatalogObjectResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "object": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "optional"
                          },
                          "relatedObjects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "categoryEnablementForCombos": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.CategoryEnablementForCombos",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.RetrieveCatalogObjectRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.RetrieveCatalogObjectResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveCatalogObjectRequest @ squareup/connect/v2/catalog/interfaces/retrieve-catalog-obj.proto at 20:1
 */
export const RetrieveCatalogObjectRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.RetrieveCatalogObjectRequest');
fixType(RetrieveCatalogObjectRequest, {
  objectId: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveCatalogObjectRequest);
/**
 * SOURCE RetrieveCatalogObjectResponse @ squareup/connect/v2/catalog/interfaces/retrieve-catalog-obj.proto at 96:1
 */
export const RetrieveCatalogObjectResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.RetrieveCatalogObjectResponse');
fixType(RetrieveCatalogObjectResponse);
Builder.createAndAttachToType(RetrieveCatalogObjectResponse);